"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const GoogleMaps = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { fill: "#07A35C", fillRule: "evenodd", d: "M0 21.784V4.337A1.838 1.838 0 011.836 2.5h17.448L0 21.784z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FFE32C",
        fillRule: "evenodd",
        d: "M0 22.15v-.366L19.284 2.5h.366a1.839 1.839 0 011.838 1.837v.367L2.203 23.988h-.367A1.838 1.838 0 010 22.15z"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#6186C4", fillRule: "evenodd", d: "M2.203 23.988l8.541-8.54 8.54 8.54H2.204z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M19.284 23.988l-8.67-8.671 2.204-2.204 8.67 8.671v.366a1.839 1.839 0 01-1.838 1.838h-.366z"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#DCDADB", fillRule: "evenodd", d: "M21.488 21.784l-8.54-8.54 8.54-8.54v17.08z" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#F6F6F6",
        d: "M8.24 7.141H5.362v.998h1.703A1.799 1.799 0 116.538 6.2l.796-.778a2.91 2.91 0 10.906 1.718z"
      }
    ),
    /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#DE4231",
        fillRule: "evenodd",
        d: "M18.43 17.73h-.008c-.185 0-.282-.139-.303-.291-.45-3.268-1.307-4.496-2.041-5.713-1.218-2.018-3.225-4.252-3.225-6.47C12.853 2.461 15.14 0 18.418 0h.017C21.713 0 24 2.461 24 5.256c0 2.218-2.007 4.454-3.225 6.473-.734 1.216-1.591 2.444-2.042 5.712-.02.149-.118.289-.302.289z"
      }
    ), /* @__PURE__ */ React.createElement("path", { fill: "#8E2F22", d: "M18.427 7.24a1.919 1.919 0 100-3.838 1.919 1.919 0 000 3.838z" }))
  );
};
export default GoogleMaps;
